
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 12.954c0-.904-.1-1.782-.475-2.485a8.147 8.147 0 00.175-1.733C17.7 3.916 13.8 0 9 0 4.2 0 .3 3.916.3 8.736c0 .578.05 1.18.175 1.733C.1 11.172 0 12.05 0 12.954c0 1.983.425 3.79 3.475 3.992v.552c0 .276.225.502.5.502s.5-.226.5-.502V8.46a.503.503 0 00-.5-.502c-.275 0-.5.226-.5.502v.553c-.925.05-1.625.276-2.125.577a9.206 9.206 0 01-.05-.828c0-4.293 3.45-7.758 7.7-7.758s7.7 3.465 7.7 7.732c0 .277-.025.553-.05.829-.5-.327-1.2-.527-2.125-.578v-.552a.503.503 0 00-.5-.502c-.275 0-.5.226-.5.502v9.038c0 .276.225.502.5.502s.5-.226.5-.502v-.552c3.05-.176 3.475-2.009 3.475-3.967zM3.475 9.967v5.95C1.2 15.765 1 14.535 1 12.953s.2-2.837 2.475-2.987zm11.05 5.95v-5.95c2.275.15 2.475 1.38 2.475 2.987 0 1.582-.2 2.812-2.475 2.962z","fill":"#979797","fill-rule":"nonzero"}})])
          )
        }
      }
    